import { gql } from '@apollo/client';

// 查詢
export const GET_MY_PROFILES = gql`
  query GetMyProfiles {
    myProfiles {
      success
      message
      profiles {
        id
        userId
        contentType
        content
        visibility
        order
        isActive
        createdAt
        updatedAt
      }
      errors {
        field
        message
      }
    }
  }
`;

export const GET_USER_PROFILES = gql`
  query GetUserProfiles($userId: ID!, $relationship: String) {
    userProfiles(userId: $userId, relationship: $relationship) {
      success
      message
      profiles {
        id
        userId
        contentType
        content
        visibility
        order
        isActive
        createdAt
        updatedAt
      }
      errors {
        field
        message
      }
    }
  }
`;

export const GET_USER_AVATAR = gql`
  query GetUserAvatar($userId: ID!, $relationship: String) {
    userAvatar(userId: $userId, relationship: $relationship) {
      id
      userId
      contentType
      content
      visibility
      order
      isActive
      createdAt
      updatedAt
    }
  }
`;

// 變更
export const CREATE_PROFILE = gql`
  mutation CreateProfile($input: CreateProfileInput!) {
    createProfile(input: $input) {
      success
      message
      profile {
        id
        userId
        contentType
        content
        visibility
        order
        isActive
        createdAt
        updatedAt
      }
      errors {
        field
        message
      }
    }
  }
`;

export const UPDATE_PROFILE = gql`
  mutation UpdateProfile($input: UpdateProfileInput!) {
    updateProfile(input: $input) {
      success
      message
      profile {
        id
        userId
        contentType
        content
        visibility
        order
        isActive
        createdAt
        updatedAt
      }
      errors {
        field
        message
      }
    }
  }
`;

export const DELETE_PROFILE = gql`
  mutation DeleteProfile($id: ID!) {
    deleteProfile(id: $id) {
      success
      message
      errors {
        field
        message
      }
    }
  }
`;

export const UPLOAD_AVATAR = gql`
  mutation UploadAvatar($file: Upload!) {
    uploadAvatar(file: $file) {
      success
      message
      filePath
      url
      errors {
        field
        message
      }
    }
  }
`;

// 獲取我的問題
export const GET_MY_QUESTIONS = gql`
  query GetMyQuestions {
    myQuestions {
      success
      message
      questions {
        id
        title
        description
        type
        options {
          text
          order
        }
        tags {
          id
          name
          description
        }
        visibility
        secret
        creatorId
        createdAt
        updatedAt
      }
      errors {
        field
        message
      }
    }
  }
`;

// 獲取我的題庫
export const GET_MY_QUESTION_SETS = gql`
  query GetMyQuestionSets {
    myQuestionSets {
      success
      message
      questionSets {
        id
        name
        description
        isDefault
        visibility
        tags {
          id
          name
          description
        }
        creatorId
        createdAt
        updatedAt
      }
      errors {
        field
        message
      }
    }
  }
`; 

// 將問題加入題庫
export const ADD_QUESTION_TO_SET = gql`
  mutation AddQuestionToSet($input: CreateQuestionSetItemInput!) {
    addQuestionToSet(input: $input) {
      success
      message
      questionSet {
        id
        name
        questionCount
      }
      errors {
        field
        message
      }
    }
  }
`;

// 更新題庫項目配分
export const UPDATE_QUESTION_SET_ITEM = gql`
  mutation UpdateQuestionSetItem($input: UpdateQuestionSetItemInput!) {
    updateQuestionSetItem(input: $input) {
      success
      message
      errors {
        field
        message
      }
    }
  }
`;

// 更新個人資料可見性（是否對配對系統開放）
export const UPDATE_PROFILE_VISIBILITY = gql`
  mutation UpdateProfileVisibility($profileOpen: Boolean!) {
    updateProfileVisibility(profileOpen: $profileOpen) {
      success
      message
      user {
        id
        username
        email
        profileOpen
      }
      errors {
        field
        message
      }
    }
  }
`;

 